var DisplayContent, DisplayHistoryContent, DisplayPartOfContent, DisplayTableContent, FormView, FormView_Change, LoadAns, LoadContent, addLocationQuestions, cancelLoadingData, checkData, checkQType, checkQTypeDisplay, cmap, createDivs, display_coordinates, finalizeLoading, getDisplayPartOfContentNew, getJSON, getPOIId, getRouteStart, loadDataAlt, loadDataTimeouts, loadMapData, loaded_locs, part_of_Questions, readMore, removePOIItems, rowidKey, setValue, showInstances;

window.current_poi_id = null;

window.isshowdata = false;

window.current_row_id = null;

part_of_Questions = [];

rowidKey = [];

loaded_locs = void 0;

display_coordinates = {};

cmap = void 0;

loadDataTimeouts = {};

DisplayContent = function(id) {
  var at, columnSet, columns, columnsArray, dataAvailable, first, firstArray, fulltext, html, isconflict, j, key, l, label, len, len1, len2, len3, locid, m, myrole, n, name, o, objPOI, page, qn, ref, ref1, ref2, ref3, sub, tableQuery, tempData, tempDataStore, value;
  if (!window.divsLoaded) {
    createDivs();
    window.divsLoaded = true;
  }
  objPOI = getPOIByID(id);
  columns = [];
  columnSet = [];
  first = [];
  firstArray = [];
  columnsArray = [];
  dataAvailable = void 0;
  isconflict = false;
  if (objPOI.layout === "columns") {
    DisplayContentTrans(id);
    return;
  }
  myrole = roles;
  if (myrole.indexOf("admin") !== -1) {
    myrole = "admin";
  } else {
    myrole = null;
  }
  $("#ft" + id)[0].style.cssText = "margin-bottom:20px;";
  $("#Forms").show();
  $("#tabView").hide();
  html = "<div class=\"alt1\">\n    <div class=\"tableLayoutRows\">\n        <div class=\"hidden\" id=\"tableLayout\">\n            <img src=\"" + image_res + "table_row.png\">\n        </div>\n        <b>\n            " + objPOI.name + "\n        </b>\n    </div>\n</div>\n<div id=\"table_" + id + "\" style=\"min-height:100px; max-height: 600px; over-flow: scroll;\">\n</div>";
  tempDataStore = new dojo.store.Memory({
    data: []
  });
  tempDataStore.comparatorMap = {};
  first[0] = {
    label: "Name",
    field: "name",
    width: "80px",
    formatter: formatText
  };
  firstArray[0] = first;
  j = 0;
  ref = objPOI.instance.pages;
  for (l = 0, len = ref.length; l < len; l++) {
    page = ref[l];
    ref1 = page.questions;
    for (m = 0, len1 = ref1.length; m < len1; m++) {
      qn = ref1[m];
      if ((qn.inVisible || !checkQTypeDisplay(qn.type)) && myrole === "admin") {
        if (qn.type !== "NameQuestion" && qn.id && qn.id !== "Location1" && qn.id !== "Location2" && qn.id !== "Location3" && qn.id !== "Location4" && qn.id !== "portalEditTime" && qn.id !== "phoneEditTime" && qn.id !== "entryTime" && qn.id !== "user_id" && qn.id !== "syncconflict" && qn.id !== "portalEditEntry") {
          continue;
        }
      } else if (qn.inVisible || !checkQTypeDisplay(qn.type)) {
        if (qn.type !== "NameQuestion" && qn.id && qn.id !== "Location1" && qn.id !== "Location2" && qn.id !== "Location3" && qn.id !== "Location4" && qn.id !== "portalEditTime" && qn.id !== "phoneEditTime" && qn.id !== "entryTime" && qn.id !== "user_id") {
          continue;
        }
      }
      if (qn.type === "Label" || qn.type === "FileQuestion") {
        continue;
      }
      if (qn.id === "Name") {
        continue;
      }
      label = null;
      if (qn.id === "Location1" || qn.id === "Location2" || qn.id === "Location3" || qn.id === "Location4") {
        locid = qn.id.substring(8, 9) - 1;
        if (locationLabels[locid]) {
          label = locationLabels[locid];
        }
      } else {
        label = qn.text;
      }
      fulltext = label;
      if (label !== null) {
        label = (label.trim()).substring(0, 20) + "...";
      }
      columns[j] = {
        label: label,
        field: qn.id,
        width: "80px",
        fulltext: fulltext,
        formatter: formatText
      };
      j++;
    }
  }
  columnSet[0] = firstArray;
  columnsArray[0] = columns;
  columnSet[1] = columnsArray;
  for (key in objPOI.instance.name) {
    if (selectedAnswersCollection.findWhere({
      "row_id": Number(key)
    }) == null) {
      continue;
    }
    if (objPOI.instance.name[key] === undefined) {
      continue;
    }
    dataAvailable = true;
    tempData = {};
    ref2 = objPOI.instance.pages;
    for (n = 0, len2 = ref2.length; n < len2; n++) {
      page = ref2[n];
      ref3 = page.questions;
      for (o = 0, len3 = ref3.length; o < len3; o++) {
        qn = ref3[o];
        if (qn.inVisible || !checkQTypeDisplay(qn.type)) {
          if (qn.type !== "NameQuestion" && qn.id !== "modified" && qn.id !== "Location1" && qn.id !== "Location2" && qn.id !== "Location3" && qn.id !== "Location4" && qn.id !== "portalEditTime" && qn.id !== "phoneEditTime" && qn.id !== "entryTime" && qn.id !== "user_id" && qn.id !== "syncconflict" && qn.id !== "portalEditEntry") {
            continue;
          }
        }
        if (qn.id === "Name") {
          name = (qn.ans[key] === "" ? "     -      " : qn.ans[key]);
          if (qn.ans[key] === void 0) {
            name = "loading...";
          }
          tempData["name"] = "<a class='pointer'>" + name + "</a>";
          tempData["id_"] = key;
          continue;
        }
        if (qn.type === "Label" || qn.type === "FileQuestion") {
          continue;
        }
        value = "";
        if (qn.type === "Part_of_Question") {
          if (qn.relations[0] !== undefined) {
            value += "<a class='pofData' id='" + key + "' name='" + getPOIId(qn.relations[0].ref) + ("' back='1'>" + messages.showpartofdata + "</a>");
          }
        } else if (qn.type === "TableQuestion") {
          value += "<a class='tableData' data-key=\"" + key + "\" onclick='window.showAnswer(window.answerCollection.findWhere({row_id: Number($(this).data(\"key\"))}))'>" + messages.showtabledata + "</a>";
        } else if ((qn.ans[key] == null) || qn.ans[key] === undefined) {
          value += "   -   ";
        } else if (qn.ans[key] === true && qn.ans[key] !== 1) {
          value += " Yes ";
        } else if (qn.ans[key] === false && qn.ans[key] !== 0) {
          value += " No ";
        } else if (qn.id === "syncconflict") {
          if (qn.ans[key] === 1) {
            value += " <a onclick='showConflicts(\"" + objPOI.id + "\",\"" + key + "\",\"" + -1 + "\",\"" + 2 + ("\")'><font color='red'>" + messages.showconflict + "</font></a>");
            isconflict = true;
          } else {
            value += "-";
          }
        } else {
          if (qn.ans[key].length > 50) {
            sub = qn.ans[key].substring(0, 50);
            value += sub + " <a onclick=\"readMore('" + qn.text.trim() + "','" + qn.ans[key].trim() + ("')\">" + messages.readmore + "</a>");
          } else {
            value += qn.ans[key];
          }
        }
        tempData[qn.id] = value;
      }
    }
    tempDataStore.put(tempData);
  }
  if (dataAvailable) {
    $("#ft" + id).html(html);
    if (!isconflict) {
      columnSet[1][0].splice(0, 1);
    }
    tableQuery = "table_" + id;
    if (loadDataTimeouts[tableQuery] != null) {
      clearTimeout(loadDataTimeouts[tableQuery]);
    }
    at = function() {
      return addTable("table_" + id, tempDataStore, columnSet, id);
    };
    return loadDataTimeouts[tableQuery] = setTimeout(at, 400);
  }
};

FormView = function(id, formNo, pof, back) {
  var a, answerButtons, answerModel, answersGroupedByFormId, b, deleteButton, evalArray, evalQuestion, exportButton, extra, extra2, extraTabs, extraTabs2, formsHtml, fv, i, j, l, len, len1, len2, len3, len4, len5, len6, len7, len8, len9, links, locid, m, model, modelToShow, n, o, options, page, q, qn, question, r, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, rel, s, skipCaller, t, tCount, temp_j, u, userLevel, userLocations, v, x, y;
  $("#mapButton").removeClass("active");
  $("#tableButton").addClass("active");
  $("#map").hide();
  $("#map-table-container .tableview").show();
  $("#instance-modal").modal("hide");
  window.current = "instance";
  window.instanceBack = back;
  window.current_poi_id = id;
  window.current_row_id = formNo;
  links = "";
  window.current_id = id;
  answersGroupedByFormId = answerCollection.groupBy(function(model) {
    return model.attributes.formId;
  });
  options = "";
  modelToShow = null;
  ref = answersGroupedByFormId[id];
  for (l = 0, len = ref.length; l < len; l++) {
    model = ref[l];
    if (model.id === Number(formNo)) {
      modelToShow = model;
      options += "<option selected value='" + model.id + "'>" + model.attributes['0'] + "</option>";
    } else if (selectedAnswersCollection.get(model.id) != null) {
      options += "<option value='" + model.id + "'>" + model.attributes['0'] + "</option>";
    }
  }
  extra = "";
  if (!editOnlyOwn) {
    extra += "<button class='btn btn-default btn-sm' id='editButton'>" + messages.savechanges + "</button> ";
  } else if (instance.editor_id[formNo] === window.userID) {
    extra += "<button class='btn btn-default btn-sm' id='editButton'>" + messages.savechanges + "</button> ";
  }
  tCount = 0;
  j = 0;
  extraTabs = "";
  ref1 = POI[id].instance.pages;
  for (m = 0, len1 = ref1.length; m < len1; m++) {
    page = ref1[m];
    extraTabs += "<li><a href='#tabs-" + (tCount + 4) + "' data-toggle='tab'>" + page.name + "</a></li>";
    tCount++;
  }
  extra2 = "";
  i = 0;
  while (i < POI[id].instance.pages.length) {
    ref2 = POI[id].instance.pages[i].questions;
    for (n = 0, len2 = ref2.length; n < len2; n++) {
      qn = ref2[n];
      if (qn.id === "ID") {
        extra2 += "<input type='hidden' id='data" + qn.id + "_" + id + "' value='" + qn.ans[formNo] + "'>";
      } else if (!((qn.inVisible || !checkQTypeDisplay(qn.type)) && (qn.id !== "Location1" && qn.id !== "Location2" && qn.id !== "Location3" && qn.id !== "Location4"))) {
        extra2 += createQuestionDisplay(qn, formNo, true, id);
      }
    }
    ref3 = POI[id].instance.pages[i].relations;
    for (o = 0, len3 = ref3.length; o < len3; o++) {
      rel = ref3[o];
      extra2 += "<div id='" + rel.id + "' class='displayQuestionDiv'>" + rel.text + " <a class='pofData' id='" + formNo + "' name='" + (getPOIId(rel.ref)) + "' back='1'> <br/> " + messages.clicktoviewsubformdata + "</a></div>";
    }
    i++;
  }
  j = 0;
  temp_j = 0;
  i = 0;
  extraTabs2 = "";
  while (i < POI[id].instance.pages.length) {
    extraTabs2 += "<div id='tabs-" + (i + 4) + "' class='tab-pane'><div style='overflow:hidden;'><fieldset>";
    ref4 = POI[id].instance.pages[i].questions;
    for (q = 0, len4 = ref4.length; q < len4; q++) {
      qn = ref4[q];
      if (qn.id === "ID") {
        extraTabs2 += "<input type='hidden' id='data" + qn.id + "' value='" + qn.ans[formNo] + "'>";
      }
      if (!((qn.inVisible || !checkQTypeDisplay(qn.type)) && (qn.id !== "Location1" && qn.id !== "Location2" && qn.id !== "Location3" && qn.id !== "Location4"))) {
        extraTabs2 += createQuestionDisplay(qn, formNo, false, id);
      }
    }
    ref5 = POI[id].instance.pages[i].relations;
    for (r = 0, len5 = ref5.length; r < len5; r++) {
      rel = ref5[r];
      rel = POI[id].instance.pages[i].relations[j];
      extraTabs2 += ("<div id='" + rel.id + "' class='displayQuestionDiv'>" + rel.text + "<a class='pofData' id='") + formNo + "' name='" + getPOIId(rel.ref) + ("' back='1'> <br/> " + messages.clicktoviewsubformdata + "</a></div>");
    }
    j = 0;
    if (POI[id].instance.locations.length === 0) {
      extraTabs2 += "<tr class=alt3><td>No data available to display on this page</td></tr>";
    }
    extraTabs2 += "</fieldset></div></div>";
    j = i;
    i++;
  }
  exportButton = "<button class=\"btn btn-default btn-sm\" onclick=\"downloadInstance(" + id + ",'" + POI[id].instance.ids[formNo] + "')\">\n    " + messages.exportData + "\n</button>";
  deleteButton = "<button class=\"btn btn-default btn-sm\" onclick=\"deletePOI(" + id + "," + formNo + ",'" + POI[id].instance.ids[formNo] + "')\">\n    " + messages.deleteData + "\n</button>";
  if (window.roles.indexOf("enumerator") !== -1) {
    exportButton = "";
  }
  if (window.roles.indexOf("viewer") !== -1) {
    exportButton = "";
    deleteButton = "";
    extra = "";
  }
  answerButtons = "<button class=\"btn btn-default btn-sm\" onclick=\"displayBack(" + pof + "," + back + ")\">\n    Back\n</button>\n" + deleteButton + "\n" + exportButton + "\n<button class=\"btn btn-default btn-sm\" onclick=\"loadHistory(" + id + ", " + formNo + ", " + pof + ", " + back + ", false)\" id=\"historyButton\">\n    History\n</button>\n" + extra;
  formsHtml = "<div class=\"row\">\n    <div class=\"col-md-6\">\n        <b>" + POI[id].name + " " + messages.datapoints + ": </b>\n        <select onchange=\"FormView_Change(" + id + ", " + pof + ", " + back + ")\" id=\"formSel\">\n            " + options + "\n        </select>\n    </div>\n    <div class=\"col-md-6\">\n        " + answerButtons + "\n    </div>\n</div>\n<form id=\"tabs-pages\" class=\"formview\">\n</form>";
  if (!window.divsLoaded) {
    createDivs();
    window.divsLoaded = true;
  }
  $("#Forms").hide();
  $("#tabView").show();
  $("#tabView").html(formsHtml);
  cmap = createMap("instanceMap", "", selectedAnswersCollection.get(formNo), null);
  $("#tabs-pages li [href='#tabs-3']").on("shown.bs.tab", function(evt) {
    if (typeof emap !== "undefined" && emap !== null) {
      emap.map.invalidateSize();
    }
    if (cmap != null) {
      return cmap.map.invalidateSize();
    }
  });
  x = 0;
  while (x < POI[id].instance.pages.length) {
    ref6 = POI[id].instance.pages[x].questions;
    for (s = 0, len6 = ref6.length; s < len6; s++) {
      qn = ref6[s];
      if (qn.type === "Part_of_Question") {
        $("#view" + qn.id).show();
        $("#edit" + qn.id).hide();
      }
    }
    x++;
  }
  y = 0;
  while (y < POI[id].instance.pages.length) {
    ref7 = POI[id].instance.pages[y].questions;
    for (t = 0, len7 = ref7.length; t < len7; t++) {
      question = ref7[t];
      if (!((question.inVisible || !checkQTypeDisplay(question.type)) && (question.id !== "Location1" && question.id !== "Location2" && question.id !== "Location3" && question.id !== "Location4"))) {
        if (question.evaluate !== "" && question.evaluate !== undefined) {
          evalArray = question.evaluate.split(",");
          a = 0;
          while (a < evalArray.length) {
            b = 0;
            while (b < POI[id].instance.pages.length) {
              ref8 = POI[id].instance.pages[b].questions;
              for (u = 0, len8 = ref8.length; u < len8; u++) {
                qn = ref8[u];
                if (qn.evaluate !== undefined && qn.evaluate.indexOf(evalArray[a]) !== -1) {
                  evalQuestion = qn;
                }
              }
              b++;
            }
            a++;
          }
          $("#" + question.id + "_" + id).addClass('skipq_' + question.id);
          $('.skipq_' + question.id).on("keyup", function() {
            return skipCaller();
          });
          $('.skipq_' + question.id).on("blur", function() {
            return skipCaller();
          });
          skipCaller = function() {
            var len9, ref9, results, v, z;
            z = 0;
            results = [];
            while (z < evalArray.length) {
              i = 0;
              while (i < POI[id].instance.pages.length) {
                ref9 = POI[id].instance.pages[i].questions;
                for (v = 0, len9 = ref9.length; v < len9; v++) {
                  qn = ref9[v];
                  if (qn.evaluate !== undefined && qn.evaluate.indexOf(evalArray[z]) !== -1) {
                    evalQuestion = qn;
                  }
                }
                i++;
              }
              results.push(z++);
            }
            return results;
          };
        }
      }
    }
    y++;
  }
  answerModel = answerCollection.findWhere({
    "row_id": formNo
  });
  if (answerModel == null) {
    answerModel = answerCollection.get(formNo);
  }
  if (answerModel.get("row_id") != null) {
    answerModel.fetch({
      row_id: answerModel.get("row_id")
    });
  } else {
    answerModel.fetch({
      row_id: answerModel.id
    });
  }
  userLocations = [];
  userLevel = _.min(window.level);
  userLevel = Number(userLevel);
  if (userLevel === 2e308) {
    userLevel = 0;
  }
  for (v = 0, len9 = location_id.length; v < len9; v++) {
    locid = location_id[v];
    userLocations = userLocations.concat(locationHierarchyView.getLocationsIn(locid));
  }
  if (userLocations.length === 0) {
    userLocations = locationHierarchyView.getAllLocations();
  }
  fv = new poimapper.FormView({
    el: $("#tabs-pages"),
    answerModel: answerModel,
    model: formCollection.get(id),
    locations: userLocations,
    locationLabels: window.locationLabels,
    userLevel: userLevel
  }).render();
  fv.createWidgets();
  $("#editButton").on("click", function() {
    return $("#tabs-pages").submit();
  });
};

LoadAns = function(id, node, level, from) {
  var doAjax, json, loadingData;
  return;
  json = getJSON(id, node.data.key, level - 1);
  if (!node.data.loading) {
    node.data.loading = [];
  }
  if (from !== "show" && !loadDataAutomatically) {
    node.data.loading[id] = "loading";
  } else if (node.data.loading[id] === "loading") {
    node.data.loading[id] = "display";
    return;
  }
  loadingData = null;
  loadingObjects.push(loadingData);
  addPOIIdToLocation(node, id);
  doAjax = function() {
    var halfling, halflingsFromUndefinedThatAreNotReallyUndefined, l, len, results;
    $.ajax({
      type: "POST",
      url: baseUrl + "app/answers/" + POI[id].answerTable + "/" + readOnlyOwn + "/" + groupID + "/" + userID + "/" + POI[id].refresh,
      data: json,
      headers: {
        "Content-Type": "application/json",
        userid: userName,
        key: pwrd
      },
      error: function(error) {
        if (error.errorCode) {
          return handleError(error);
        }
      },
      success: function(result) {
        var ac, dataSize, fc, iN, index, j, l, len, len1, len2, lname, m, n, p, pof, pofinst, question, ref, rid, tble, tbleinst, temp, url;
        answers[id] = result;
        fc = 0;
        ac = 0;
        closeProgress();
        if (answers[id].questionList[0].answers != null) {
          dataSize = answers[id].questionList[0].answers.length;
        } else {
          dataSize = 0;
        }
        if (dataSize > 0) {
          index = 0;
          while (index < dataSize) {
            ref = answers[id].questionList;
            for (l = 0, len = ref.length; l < len; l++) {
              question = ref[l];
              if (question.answers && (question.answers[index] != null)) {
                if (question.answers[index][0] == null) {
                  setValue("", question.fieldName, id, question.answers[index][1]);
                } else if (question.answers[index][0] === true) {
                  setValue("Yes", question.fieldName, id, question.answers[index][1]);
                } else if (question.answers[index][0] === false) {
                  setValue("No", question.fieldName, id, question.answers[index][1]);
                } else if (question.fieldName === "Location1" || question.fieldName === "Location2" || question.fieldName === "Location3" || question.fieldName === "Location4") {
                  lname = getLocationName(question.answers[index][0]);
                  setValue(lname, question.fieldName, id, question.answers[index][1]);
                } else if (question.fieldName === "modified") {
                  setValue(question.answers[index][0], question.fieldName, id, question.answers[index][1]);
                } else if (question.fieldName === "user_id") {
                  POI[id].instance.editor_id[question.answers[index][1]] = question.answers[index][0];
                  setValue(users_name[question.answers[index][0]], question.fieldName, id, question.answers[index][1]);
                } else if (question.fieldName === "Coordinates") {
                  if (question.answers[index][0]) {
                    p = getCoordinates(question.answers[index][0]);
                    setValue(p[0].replace(" ", "") + " " + p[1].replace(" ", ""), question.fieldName, id, question.answers[index][1]);
                  }
                } else {
                  setValue(question.answers[index][0], question.fieldName, id, question.answers[index][1]);
                }
                ac++;
              }
            }
            index++;
          }
          addPOIIdToLocation(node, id);
          if (from !== "show" && !loadDataAutomatically) {
            if (node.data.loading[id] === "display") {
              displayDataAlt(id, node, level);
              closeProgress();
            }
            node.data.loading[id] = "loaded";
          } else {
            if (!node.data.loading) {
              node.data.loading = [];
            }
            node.data.loading[id] = "loaded";
            displayDataAlt(id, node, level);
            closeProgress();
          }
        } else {
          displayDataAlt(id, node, level);
          addPOIIdToLocation(node, id);
          closeProgress();
          return;
        }
        if (answers[id].imageNo) {
          j = 0;
          while (answers[id].imageNo && j < answers[id].imageNo.length) {
            rid = answers[id].imageNo[j][0];
            iN = answers[id].imageNo[j][1];
            url = null;
            if (answers[id].imageNo[j][3]) {
              url = answers[id].imageNo[j][3];
            }
            if (!POI[id].instance.imageNo[rid]) {
              POI[id].instance.imageNo[rid] = [];
            }
            temp = [];
            temp.push(iN);
            temp.push(url);
            temp.push(answers[id].imageNo[j][2]);
            temp.push(answers[id].imageNo[j][4]);
            POI[id].instance.imageNo[rid].push(temp);
            j++;
          }
        }
        pof = part_of_Questions[id];
        for (m = 0, len1 = pof.length; m < len1; m++) {
          pofinst = pof[m];
          loadPartOfData(getPOIId(pofinst), id, false);
        }
        tble = tableQuestions[id];
        for (n = 0, len2 = tble.length; n < len2; n++) {
          tbleinst = tble[n];
          loadPartOfData(getPOIId(tbleinst), id, false);
        }
        return DisplayContent(id);
      }
    });
    halflingsFromUndefinedThatAreNotReallyUndefined = locationHierarchyView.getHalflings();
    results = [];
    for (l = 0, len = halflingsFromUndefinedThatAreNotReallyUndefined.length; l < len; l++) {
      halfling = halflingsFromUndefinedThatAreNotReallyUndefined[l];
      json = getJSON(id, halfling, level - 1);
      results.push($.ajax({
        type: "POST",
        url: baseUrl + "app/answers/" + POI[id].answerTable + "/" + readOnlyOwn + "/" + groupID + "/" + userID + "/" + POI[id].refresh,
        data: json,
        headers: {
          "Content-Type": "application/json",
          userid: userName,
          key: pwrd
        },
        error: function(error) {
          if (error.errorCode) {
            return handleError(error);
          }
        },
        success: function(result) {
          var ac, dataSize, fc, iN, index, j, len1, len2, len3, lname, m, n, o, p, pof, pofinst, question, ref, results1, rid, tble, tbleinst, temp, url;
          answers[id] = result;
          fc = 0;
          ac = 0;
          closeProgress();
          if (answers[id].questionList[0].answers != null) {
            dataSize = answers[id].questionList[0].answers.length;
          } else {
            dataSize = 0;
          }
          if (dataSize > 0) {
            index = 0;
            while (index < dataSize) {
              ref = answers[id].questionList;
              for (m = 0, len1 = ref.length; m < len1; m++) {
                question = ref[m];
                if (question.answers && (question.answers[index] != null)) {
                  if (question.answers[index][0] == null) {
                    setValue("", question.fieldName, id, question.answers[index][1]);
                  } else if (question.answers[index][0] === true) {
                    setValue("Yes", question.fieldName, id, question.answers[index][1]);
                  } else if (question.answers[index][0] === false) {
                    setValue("No", question.fieldName, id, question.answers[index][1]);
                  } else if (question.fieldName === "Location1" || question.fieldName === "Location2" || question.fieldName === "Location3" || question.fieldName === "Location4") {
                    lname = getLocationName(question.answers[index][0]);
                    setValue(lname, question.fieldName, id, question.answers[index][1]);
                  } else if (question.fieldName === "modified") {
                    setValue(question.answers[index][0], question.fieldName, id, question.answers[index][1]);
                  } else if (question.fieldName === "user_id") {
                    POI[id].instance.editor_id[question.answers[index][1]] = question.answers[index][0];
                    setValue(users_name[question.answers[index][0]], question.fieldName, id, question.answers[index][1]);
                  } else if (question.fieldName === "Coordinates") {
                    if (question.answers[index][0]) {
                      p = getCoordinates(question.answers[index][0]);
                      setValue(p[0].replace(" ", "") + " " + p[1].replace(" ", ""), question.fieldName, id, question.answers[index][1]);
                    }
                  } else {
                    setValue(question.answers[index][0], question.fieldName, id, question.answers[index][1]);
                  }
                  ac++;
                }
              }
              index++;
            }
            addPOIIdToLocation(node, id);
            if (from !== "show" && !loadDataAutomatically) {
              if (node.data.loading[id] === "display") {
                displayDataAlt(id, node, level);
              }
              node.data.loading[id] = "loaded";
            } else {
              if (!node.data.loading) {
                node.data.loading = [];
              }
              node.data.loading[id] = "loaded";
              displayDataAlt(id, node, level);
            }
          } else {
            displayDataAlt(id, node, level);
            addPOIIdToLocation(node, id);
            return;
          }
          if (answers[id].imageNo) {
            j = 0;
            while (answers[id].imageNo && j < answers[id].imageNo.length) {
              rid = answers[id].imageNo[j][0];
              iN = answers[id].imageNo[j][1];
              url = null;
              if (answers[id].imageNo[j][3]) {
                url = answers[id].imageNo[j][3];
              }
              if (!POI[id].instance.imageNo[rid]) {
                POI[id].instance.imageNo[rid] = [];
              }
              temp = [];
              temp.push(iN);
              temp.push(url);
              temp.push(answers[id].imageNo[j][2]);
              temp.push(answers[id].imageNo[j][4]);
              POI[id].instance.imageNo[rid].push(temp);
              j++;
            }
          }
          pof = part_of_Questions[id];
          for (n = 0, len2 = pof.length; n < len2; n++) {
            pofinst = pof[n];
            loadPartOfData(getPOIId(pofinst), id, false);
          }
          tble = tableQuestions[id];
          results1 = [];
          for (o = 0, len3 = tble.length; o < len3; o++) {
            tbleinst = tble[o];
            results1.push(loadPartOfData(getPOIId(tbleinst), id, false));
          }
          return results1;
        }
      }));
    }
    return results;
  };
  return loadingObjects[loadingObjects.length - 1] = doAjax();
};

loadDataAlt = function(id, node, level, from) {
  var cont, dataId, l, len, ref;
  cont = false;
  if (node.data.poiIds) {
    ref = node.data.poiIds;
    for (l = 0, len = ref.length; l < len; l++) {
      dataId = ref[l];
      if (dataId === id && !POI[id].refresh) {
        cont = true;
        displayDataAlt(id, node, level);
      }
    }
  }
  if (!cont) {
    return LoadAns(id, node, level, from);
  }
};


/*
Sets the value for a given question.

value - The value to be set
identifier - The question identifier
id - The POI type id
row_id - The row id of the value being set
 */

setValue = function(value, identifier, id, row_id) {
  var d, hr, i, j, min, qn, sq, x;
  i = 0;
  if (POI[id] == null) {
    return;
  }
  while (i < POI[id].instance.pages.length) {
    j = 0;
    while (j < POI[id].instance.pages[i].questions.length) {
      qn = POI[id].instance.pages[i].questions[j];
      if (identifier === "Name") {
        POI[id].instance.name[row_id] = value;
      }
      if (identifier === "row_id1") {
        POI[id].instance.row_id1[row_id] = value;
      }
      if (qn.id === identifier) {
        if (value !== "") {
          if (qn.type === "TimeQuestion") {
            d = new Date(value);
            value = (d.toLocaleDateString()) + ", " + (d.toLocaleTimeString());
          }
          if (identifier === "phoneEditTime" || identifier === "portalEditTime") {
            value = value / 1000;
            value = Math.round(value);
            if (value > 60) {
              min = value / 60;
              min = Math.round(min);
              x = value % 60;
              value = min;
              if (value > 60) {
                hr = value / 60;
                hr = Math.round(hr);
                min = value % 60;
                x = min % 60;
                qn.ans[row_id] = hr + " Hr " + min + " min " + x + " sec";
              } else {
                qn.ans[row_id] = min + " min " + x + " sec";
              }
            } else {
              if (!isNaN(value)) {
                qn.ans[row_id] = value + " s";
              } else {
                qn.ans[row_id] = " - ";
              }
            }
            return;
          }
        }
        qn.ans[row_id] = value;
        return;
      }
      if (qn.hasSubquestions === true) {
        sq = getSubQuestion(qn, identifier);
        if (sq != null) {
          sq.ans[row_id] = value;
          return;
        }
      }
      j++;
    }
    i++;
  }
  i = 0;
  while (i < POI[id].instance.questions.length) {
    qn = POI[id].instance.questions[i];
    if (identifier === "Name") {
      POI[id].instance.name[row_id] = value;
    }
    if (identifier === "row_id1") {
      POI[id].instance.row_id1[row_id] = value;
    }
    if (qn.id === identifier) {
      if (value !== "") {
        if (qn.type === "TimeQuestion") {
          d = new Date(value);
          value = (d.toLocaleDateString()) + ", " + (d.toLocaleTimeString());
        }
        if (identifier === "phoneEditTime" || identifier === "portalEditTime") {
          value = value / 1000;
          value = Math.round(value);
          if (value > 60) {
            min = value / 60;
            min = Math.round(min);
            x = value % 60;
            value = min;
            if (value > 60) {
              hr = value / 60;
              hr = Math.round(hr);
              min = value % 60;
              x = min % 60;
              qn.ans[row_id] = hr + " Hr " + min + " min " + x + " sec";
            } else {
              qn.ans[row_id] = min + " min " + x + " sec";
            }
          } else {
            if (!isNaN(value)) {
              qn.ans[row_id] = value + " s";
            } else {
              qn.ans[row_id] = " - ";
            }
          }
          return;
        }
      }
      qn.ans[row_id] = value;
      return;
    }
    i++;
  }
};

loadMapData = function(id, location_id, level, center, zoom) {};

createDivs = function() {};

cancelLoadingData = function() {
  var i, results, xhr;
  i = 0;
  results = [];
  while (i < loadingObjects.length) {
    xhr = loadingObjects[i];
    xhr.abort();
    loadingObjects.splice(i, 1);
    results.push(i++);
  }
  return results;
};

$("#progress-modal .modal-footer button").on("click", cancelLoadingData);


/*
Loads the form structure from the database and object list
The object list has name, coordinates, modified date.

id - The id of the form to be loaded
refresh - a boolean indicating if the request will be for refreshing data.
true - This is a refresh
false - This is a normal load request
 */

LoadContent = function(id, refresh) {
  var json;
  if (POI[id] && POI[id].loaded === true && !refresh) {
    ft_checked[id] = true;
    applyLocationFilterNew(id);
    if (loadDataAutomatically) {
      checkData(id, "auto");
    } else {
      closeProgress();
    }
    return;
  }
  json = {};
  json["readOwn"] = readOnlyOwn;
  return $.ajax({
    type: "POST",
    url: baseUrl + "app/form/" + id + "/" + readOnlyOwn + "/" + groupID + "/" + userID + "/" + refresh,
    headers: {
      "Content-Type": "application/json",
      userid: userName,
      key: pwrd
    },
    success: function(result) {
      var answer, answerDate, answerId, answerUUID, answers, assignedLocation, coodinates, count, dataSize, datea_, day, fc, filterAccordingToLocation, form, i, includeImages, index, instance, j, l, len, len1, li, liLink, listitem, locationHierarchy, m, mon, newIds, oldIds, parents, pp, question, ref, ref1, si, siLink, str, tempLocation, tempQ, undefinedLocation, yr;
      answers = [];
      if (result.objList) {
        ref = result.objList;
        for (l = 0, len = ref.length; l < len; l++) {
          answer = ref[l];
          form = formCollection.get(id);
          i = 0;
          locationHierarchy = [];
          while (i < 4) {
            if (i === 0) {
              parents = _.pluck($("#tree").dynatree("getRoot").getChildren(), "data");
              parents = _.pluck(parents, "key");
              if (!_.contains(parents, String(answer[i]))) {
                locationHierarchy = ["0ul0"];
              }
            }
            locationHierarchy.push(answer[i]);
            i++;
          }
          filterAccordingToLocation = true;
          ref1 = window.location_id;
          for (m = 0, len1 = ref1.length; m < len1; m++) {
            assignedLocation = ref1[m];
            filterAccordingToLocation = !(_.contains(locationHierarchy, Number(assignedLocation)) || _.contains(locationHierarchy, "0ul0"));
            if (!filterAccordingToLocation) {
              break;
            }
          }
          if (filterAccordingToLocation === true && window.location_id[0] !== "") {
            continue;
          }
          answer = _.rest(answer, 4);
          answerId = answer[1];
          answerDate = answer[2];
          answerUUID = answer[4];
          answer = _.object(Object.keys(answer), answer);
          answer.name = answer['0'];
          answer.row_id = answer['1'];
          answer.coordinates = answer['3'];
          answer.id = answerUUID;
          answer.answerDate = answerDate;
          answer.uuid = answerUUID;
          undefinedLocation = _.every(locationHierarchy, function(loc) {
            return loc === null;
          });
          if (undefinedLocation) {
            locationHierarchy = ["0ul0"];
          }
          answer.locationHierarchy = locationHierarchy;
          answer.formName = result.questionnaire.name;
          answer.formId = form.attributes.id;
          answer.questionnaire_id = form.attributes.id;
          if (form.attributes.largeIcon) {
            answer.largeIcon = form.attributes.largeIcon;
            answer.largeIconLink = "/icons/" + db + "/large/" + form.attributes.largeIcon;
          } else {
            answer.largeIconLink = "/icons/large/poi_" + ((formCollection.indexOf(formCollection.get(form.attributes.id)) % 20) + 1) + ".png";
          }
          if (form.attributes.smallIcon) {
            answer.smallIcon = form.attributes.smallIcon;
            answer.smallIconLink = "/icons/" + db + "/small/" + form.attributes.smallIcon;
          } else {
            answer.smallIconLink = "/icons/small/poi_" + ((formCollection.indexOf(formCollection.get(form.attributes.id)) % 20) + 1) + ".png";
          }
          answers.push(new poimapper.AnswerModel(answer));
        }
        answerCollection.add(answers);
      }
      ques[id] = result;
      return;
      instance = POI[id].instance;
      si = POI[id].smallIcon;
      siLink = POI[id].smallIconLink;
      li = POI[id].largeIcon;
      liLink = POI[id].largeIconLink;
      includeImages = POI[id].includeImages;
      if (!ques[id].objList) {
        POI[id] = new POI(ques[id].questionnaire.questionPage.length, 0);
        POI[id].hasLocations = false;
      } else {
        POI[id] = new POI(ques[id].questionnaire.questionPage.length, ques[id].objList.length);
      }
      POI[id].id = id;
      POI[id].type = ques[id].questionnaire.type;
      POI[id].answerTable = ques[id].answerTable;
      POI[id].name = ques[id].questionnaire.name;
      POI[id].includeImages = includeImages;
      POI[id].child = ques[id].questionnaire.isChild;
      i = 0;
      while (i < ques[id].questionnaire.questionPage.length) {
        fc = 0;
        POI[id].ques.pages[i].name = ques[id].questionnaire.questionPage[i].name;
        POI[id].ques.pages[i].pageNo = ques[id].questionnaire.questionPage[i].pageNumber;
        pp = new Pages();
        pp.name = ques[id].questionnaire.questionPage[i].name;
        pp.number = ques[id].questionnaire.questionPage[i].pageNumber;

        /*
        size = 0
        if ques[id].questionnaire.questionPage[i].question
            size = ques[id].questionnaire.questionPage[i].question.length
        
        size = size + 4  if ques[id].questionnaire.hasLocationHierarchy is true and (i is 0)
         */
        j = 0;
        while (ques[id].questionnaire.questionPage[i].question && j < ques[id].questionnaire.questionPage[i].question.length) {
          tempQ = ques[id].questionnaire.questionPage[i].question[j];
          question = new Questions();
          question.id = ques[id].questionnaire.questionPage[i].question[j].id;
          question.text = ques[id].questionnaire.questionPage[i].question[j].text;
          question.type = ques[id].questionnaire.questionPage[i].question[j].type;
          question.evaluate = ques[id].questionnaire.questionPage[i].question[j].evaluate;
          question.script = ques[id].questionnaire.questionPage[i].question[j].script;
          question.spssvariable = ques[id].questionnaire.questionPage[i].question[j].spssvariable;
          question.optional = ques[id].questionnaire.questionPage[i].question[j].optional;
          question.inVisible = ques[id].questionnaire.questionPage[i].question[j].inVisible;
          if (tempQ.listItems && (tempQ.type !== "Part_of_Question")) {
            listitem = ques[id].questionnaire.questionPage[i].question[j].listItems.listItem;
            question.options = listitem;
          }
          if (tempQ.listItems && (tempQ.type === "Part_of_Question")) {
            listitem = tempQ.listItems.relation;
            question.relations = listitem;
          } else {

          }
          checkSubQuestions(question, ques[id].questionnaire.questionPage[i].question[j], POI[id].ques.pages[i]);
          j++;
        }
        i++;
      }
      POI[id].smallIcon = si;
      POI[id].largeIcon = li;
      POI[id].smallIconLink = siLink;
      POI[id].largeIconLink = liLink;
      POI[id].instance = instance;
      count = 0;
      dataSize = 0;
      if (ques[id].objList) {
        dataSize = ques[id].objList.length;
      }
      index = 0;
      i = 0;
      oldIds = [];
      newIds = [];
      if (dataSize > 0) {
        while (i < dataSize) {
          count++;
          POI[id].ques.forms[i].location = [];
          POI[id].ques.forms[i].ans = [];
          tempLocation = [];
          j = 0;
          while (j < 4) {
            POI[id].ques.forms[i].location[j] = ques[id].objList[i][j];
            tempLocation[j] = ques[id].objList[i][j];
            if (tempLocation[j] != null) {
              POI[id].instance.loadedLocs[tempLocation[j]] = [true, false];
            }
            if ((tempLocation[j] == null) && j > 0 && (tempLocation[j - 1] != null)) {
              POI[id].instance.loadedLocs[tempLocation[j - 1]] = [true, true];
            }
            if (j === 3 && (tempLocation[j] != null)) {
              POI[id].instance.loadedLocs[tempLocation[j]] = [true, true];
            }
            j++;
          }
          if ((tempLocation[0] == null) && (tempLocation[1] == null) && (tempLocation[2] == null) && (tempLocation[3] == null)) {
            POI[id].instance.loadedLocs["0ul0"] = [true, true];
          }
          POI[id].ques.forms[i].name = ques[id].objList[i][4];
          POI[id].ques.forms[i].rowId = ques[id].objList[i][5];
          POI[id].instance.locations[POI[id].ques.forms[i].rowId] = tempLocation;
          POI[id].instance.name[POI[id].ques.forms[i].rowId] = ques[id].objList[i][4];
          POI[id].instance.ids[POI[id].ques.forms[i].rowId] = ques[id].objList[i][8];
          if (refresh) {
            oldIds[POI[id].ques.forms[i].rowId] = ques[id].objList[i][8];
            newIds.push(POI[id].ques.forms[i].rowId);
          }
          str = ques[id].objList[i][6];
          day = "";
          mon = "";
          yr = "";
          j = 0;
          while (str[j] !== " ") {
            day += str[j];
            j++;
          }
          j++;
          POI[id].ques.forms[i].date.day = parseInt(day);
          while (str[j] !== " ") {
            mon += str[j];
            j++;
          }
          j++;
          while (j < str.length) {
            yr += str[j];
            j++;
          }
          if (ques[id].objList[i][7]) {
            if (POI[id].type === "AREA" || POI[id].type === "ROUTE") {
              coodinates = getRouteStart(ques[id].objList[i][7]);
              if (coodinates !== undefined) {
                POI[id].instance.coordinates[POI[id].ques.forms[i].rowId] = trim(coodinates.substring(coodinates.indexOf(" "), coodinates.length)) + " " + trim(coodinates.substring(0, coodinates.indexOf(" ")));
              }
            } else {
              coodinates = getCoordinates(ques[id].objList[i][7]);
              if (coodinates != null) {
                POI[id].instance.coordinates[POI[id].ques.forms[i].rowId] = coodinates[0].replace(" ", "") + " " + coodinates[1].replace(" ", "");
              }
            }
          }
          mon = getMonth(mon);
          datea_ = new Date_();
          datea_.month = parseInt(mon);
          datea_.year = parseInt(yr);
          datea_.day = parseInt(day);
          POI[id].instance.dates[POI[id].ques.forms[i].rowId] = datea_;
          i++;
        }
        if (refresh) {
          POI[id].refresh = true;
          deleteOldPois(oldIds, newIds, id);
          newIds = [];
        }
        finalizeLoading(id, count);
      } else {
        finalizeLoading(id, count);
        if (refresh) {
          deleteOldPois(oldIds, newIds, id);
        }
      }
      return $(document).trigger("contentLoaded");
    },
    error: function() {
      return closeProgress();
    }
  });
};

getDisplayPartOfContentNew = function(id, parentId, back) {
  var html, i, j, key, objPOI, qn, tCount;
  objPOI = getPOIByID(id);
  if (objPOI === undefined) {
    return "";
  }
  html = "<div class=alt1><b>" + objPOI.name + "</b>";
  html += "<div id='tabs-" + id + "'><ul>";
  tCount = 0;
  for (key in objPOI.instance.row_id1) {
    if (objPOI.instance.row_id1[key] === Number(parentId)) {
      html += "<li><a href=#tabs-" + tCount + ">" + objPOI.instance.name[key] + "</a></li>";
      tCount++;
    }
  }
  html += "</ul>";
  if (tCount === 0) {
    return html += "</div><p>" + objPOI.name + " has no data.</p>";
  }
  tCount = 0;
  for (key in objPOI.instance.row_id1) {
    if (objPOI.instance.row_id1[key] === Number(parentId)) {
      html += "<div id='tabs-" + tCount + "'><fieldset>";
      i = 0;
      while (i < objPOI.instance.pages.length) {
        j = 0;
        while (j < POI[id].instance.pages[i].questions.length) {
          qn = objPOI.instance.pages[i].questions[j];
          if (qn.id === "ID") {
            html += "<input type='hidden' id='data" + qn.id + "' value='" + qn.ans[key] + "'>";
          }
          if (!((objPOI.instance.pages[i].questions[j].inVisible || !checkQTypeDisplay(objPOI.instance.pages[i].questions[j].type)) && (qn.id !== "Location1" && qn.id !== "Location2" && qn.id !== "Location3" && qn.id !== "Location4"))) {
            html += createQuestionDisplay(qn, key, true, id);
          }
          j++;
        }
        i++;
      }
      tCount++;
      html += "</fieldset>";
      html += "<div id=\"SliderName_" + id + "_" + key + "\" style=\"border-style:solid;border-width:5px \"></div>";
      html += "</div>";
    }
  }
  html += "</div>";
  return html;
};

readMore = function(question, value) {
  $("#instancedata").html("<strong>" + question + "</strong><br/>" + value);
  $("#instance-modal h3").html("Data");
  return $("#instance-modal").modal("show");
};


/*
Displays the Part Of data
id - POI id
parentId - The parent row id
 */

DisplayPartOfContent = function(id, parentId, back) {
  var html, objPOI;
  html = getDisplayPartOfContentNew(id, parentId, back);
  objPOI = getPOIByID(id);
  $("#instancedata").html(html);
  $("#instance-modal h3").html(objPOI.name + " data");
  return $("#instance-modal").modal("show");
};


/*
Displays the Part Of data
id - POI id
parentId - The parent row id
 */

DisplayTableContent = function(id, parentId) {
  var html, objPOI;
  return;
  html = getDisplayTableContent(id, parentId);
  objPOI = getPOIByID(id);
  $("#instancedata").html(html);
  $("#instance-modal h3").html(POI[id].name);
  return $("#instance-modal").modal("show");
};


/*
This function shows all the instances that are related to a location

used from location hierarchy
 */

showInstances = function(poiId, location, level, name) {
  var ht, key, locs, poi;
  document.getElementById("instancedata").innerHTML = "";
  ht = "";
  poi = POI[poiId].instance.name;
  locs = POI[poiId].instance.locations;
  for (key in poi) {
    if (locs[key][level - 1] === Number(location)) {
      ht += "<a href='#' id='" + key + "' class='poi_id' name='" + poiId + "'>" + poi[key] + "</a><br/>";
    } else {
      if (location === "0ul0" && (locs[key][0] == null) && (locs[key][1] == null) && (locs[key][2] == null) && (locs[key][3] == null)) {
        ht += "<a href='#' id='" + key + "' class='poi_id' name='" + poiId + "'>" + poi[key] + "</a><br/>";
      }
    }
  }
  ht += "";
  document.getElementById("instancedata").innerHTML = ht;
  $("#instance-modal").modal("show");
  return $("#instance-modal h3").html(POI[poiId].name + " in " + name);
};

checkQType = function(type) {
  if (type !== "IdQuestion" && type !== "PicturesQuestion" && type !== "Part_of_Question" && type !== "TimeQuestion" && type !== "TableQuestion" && type !== "Label" && type !== "HeaderQuestion" && type !== "SkipQuestion") {
    return true;
  } else {
    return false;
  }
};

checkData = function(id, from) {
  var i, results;
  loaded_locs = getTreeSelectedNodes();
  if (loaded_locs.length <= 0) {
    closeProgress();
  }
  i = 0;
  results = [];
  while (i < loaded_locs.length) {
    loadDataAlt(id, loaded_locs[i], loaded_locs[i].getLevel(), from);
    results.push(i++);
  }
  return results;
};

finalizeLoading = function(id, count) {
  window.POI[id].instance.count = count;
  window.ft_checked[id] = true;
  window.POI[id].loaded = true;
  applyLocationFilterNew(id);
  if (count > 0) {
    checkData(id, "auto");
  }
  return closeProgress();
};

getRouteStart = function(route) {
  var cords, p, points;
  cords = route.substring(route.lastIndexOf("(") + 1, route.indexOf(")"));
  points = cords.split(",");
  p = points[0];
  return p;
};

removePOIItems = function(id, key) {
  deletePOIMarker(id, key);
  window.display_data[key] = false;
  return window.display_coordinates[key] = false;
};

checkQTypeDisplay = function(type) {
  if (type === "IdQuestion" || type === "PicturesQuestion" || type === "TimeQuestion") {
    return false;
  }
  return true;
};

addLocationQuestions = function(instance, pageIndex, j) {
  var i, question;
  i = 0;
  while (i < 4) {
    question = new Questions();
    question.id = "Location" + (i + 1);
    question.text = "Location " + (i + 1);
    question.type = "Location" + (i + 1) + "Question";
    question.optional = true;
    question.inVisible = false;
    instance.pages[pageIndex].questions.push(question);
    i++;
  }
};


/*
Returns the POI id given the identifier.
 */

getPOIId = function(identifier) {
  var key;
  for (key in POI) {
    if (POI[key].identifier === identifier) {
      return key;
    }
  }
};

FormView_Change = function(id, pof, back) {
  var formNo;
  formNo = $("#formSel")[0].value;
  return FormView(id, formNo, pof, back);
};


/*
@description : the function displays the history in the central-pane for a given POI
@param id : the "id" of a selected POI
@param formId : the "row id" of the POI Instance
 */

DisplayHistoryContent = function(id, formId, pof, back, conflict) {
  var columnSet, columns, columnsArray, dataAvailable, divsLoaded, first, firstArray, history, html, i, k, key, l, len, len1, m, objPOI, page, qn, question, ref, ref1, sqText, tempData, tempDataStore, value;
  if (!divsLoaded) {
    createDivs();
    divsLoaded = true;
  }
  objPOI = getPOIByID(id);
  columns = [];
  columnSet = [];
  first = [];
  firstArray = [];
  columnsArray = [];
  dataAvailable = void 0;
  history = objPOI.instance.old[formId];
  value = void 0;
  $("#ft" + id)[0].style.cssText = "margin-bottom:20px;";
  $("#Forms")[0].style.cssText = "";
  $("#tabView").hide();
  if ($("#ft" + id).html() !== "") {
    $("#ft" + id).html("");
  }
  html = "<div class='alt1'><b>" + objPOI.name + "</b> <a class='backbtn button-blue' onclick='showAnswer(answerCollection.findWhere({row_id:" + formId + "}))'>Back</a></div><div id='table_" + id + "' style='height:500px; max-height: 600px; over-flow: auto;'></div>";
  tempDataStore = new dojo.store.Memory({
    data: []
  });
  first[0] = {
    label: "Name",
    field: "name",
    width: "80px"
  };
  firstArray[0] = first;
  i = 0;
  key = void 0;
  for (key in history) {
    if (conflict && (objPOI.instance.pages[0].questions[0].ans[history[key]] === 1)) {
      columns[i] = {
        label: objPOI.instance.name[history[key]],
        field: history[key],
        width: "80px",
        formatter: formatText
      };
      dataAvailable = true;
      i++;
    } else if (!conflict) {
      columns[i] = {
        label: objPOI.instance.name[history[key]],
        field: history[key],
        width: "80px",
        formatter: formatText
      };
      dataAvailable = true;
      i++;
    }
  }
  columns[i] = {
    label: objPOI.instance.name[formId],
    field: formId,
    width: "80px",
    formatter: formatText
  };
  columnSet[0] = firstArray;
  columnsArray[0] = columns;
  columnSet[1] = columnsArray;
  ref = objPOI.instance.pages;
  for (i = l = 0, len = ref.length; l < len; i = ++l) {
    page = ref[i];
    if (dataAvailable) {
      ref1 = page.questions;
      for (k = m = 0, len1 = ref1.length; m < len1; k = ++m) {
        question = ref1[k];
        qn = question;
        tempData = {};
        if (qn.inVisible || !checkQTypeDisplay(qn.type)) {
          if (conflict) {
            if (qn.type !== "NameQuestion" && qn.id !== "modified" && qn.id !== "Location1" && qn.id !== "Location2" && qn.id !== "Location3" && qn.id !== "Location4" && qn.id !== "portalEditTime" && qn.id !== "phoneEditTime" && qn.id !== "entryTime" && qn.id !== "user_id" && qn.id !== "syncconflict") {
              continue;
            }
          } else {
            if (qn.type !== "NameQuestion" && qn.id !== "modified" && qn.id !== "Location1" && qn.id !== "Location2" && qn.id !== "Location3" && qn.id !== "Location4" && qn.id !== "portalEditTime" && qn.id !== "phoneEditTime" && qn.id !== "entryTime" && qn.id !== "user_id") {
              continue;
            }
          }
        }
        if (question.id === "Name") {
          continue;
        }
        sqText = "";
        if (qn.hasSubquestions) {
          sqText = " hasSubquestion ";
        }
        tempData.name = qn.text;
        for (key in history) {
          sqText = "";
          if (qn.hasSubquestions) {
            sqText = " class='pointer' onclick='showAnswer(answerCollection.findWhere({row_id:" + key + "}))'";
          }
          value = "";
          if (qn.type === "Part_of_Question") {
            value += "<a class='pofData' id='" + history[key] + "' name='" + getPOIId(qn.relations[0].ref) + "' back='1'>Show Part Of Data</a>";
          } else if (qn.type === "TableQuestion") {
            value += "<a class='tableData' id='" + key + "' name='" + getPOIId(qn.table.columns.ref) + "'>Show table data</a>";
          } else if (qn.ans[history[key]] === null || qn.ans[history[key]] === undefined) {
            value += "   -   ";
          } else if (qn.ans[history[key]] === true && qn.type === "BooleanQuestion") {
            value += " Yes ";
          } else if (qn.ans[history[key]] === false && qn.type === "BooleanQuestion") {
            value += " No ";
          } else if (qn.id === "syncconflict") {
            if (qn.ans[history[key]] === 1) {
              value += "<a class='pointer'><font color='red'>*****</font></a>";
            } else {
              value += "-";
            }
          } else {
            value += qn.ans[history[key]];
          }
          tempData[history[key]] = value;
        }
        value = "";
        if (qn.type === "Part_of_Question") {
          value += "<a class='pofData' id='" + history[key] + "' name='" + getPOIId(qn.relations[0].ref) + "' back='1'>Show Part Of Data</a>";
        } else if (qn.type === "TableQuestion") {
          value += "<a class='tableData' id='" + key + "' name='" + getPOIId(qn.table.columns.ref) + "'>Show table data</a>";
        } else if (qn.ans[formId] === null || qn.ans[formId] === undefined) {
          value += "   -   ";
        } else if (qn.ans[formId] === true && qn.type === "BooleanQuestion") {
          value += " Yes ";
        } else if (qn.ans[formId] === false && qn.type === "BooleanQuestion") {
          value += " No ";
        } else if (qn.id === "syncconflict") {
          if (qn.ans[formId] === 1) {
            value += " <a onclick='showAnswer(answerCollection.findWhere({row_id:" + formId + "}));viewConflicts(\"" + formId + "\",\"" + id + "\");'><font color='red'>***** [Resolve Conflict]</font></a>";
          } else {
            value += "-";
          }
        } else {
          value += qn.ans[formId];
        }
        tempData[formId] = value;
        tempDataStore.put(tempData);
        k++;
      }
    }
    i++;
  }
  if (dataAvailable) {
    $("#ft" + id).html(html);
    addTable("table_" + id, tempDataStore, columnSet, id);
  }
};

getJSON = function(id, locationID, level) {
  var formModel, i, j, json, page, qn;
  formModel = window.formCollection.get(id);
  if (formModel == null) {
    return;
  }
  json = {
    "questionList": []
  };
  i = 0;
  while (i < formModel.get("questionPage").length) {
    j = 0;
    page = formModel.get("questionPage")[i];
    while (j < page.question.length) {
      qn = page.question[j];
      if (qn != null) {
        if (qn.type === "FileQuestion") {

        } else if (checkQType(qn.type) && (!qn.inVisible || (qn.type === "Location1Question" || qn.type === "Location2Question" || qn.type === "Location3Question" || qn.type === "Location4Question")) || qn.type === "NameQuestion" || qn.id === "Area" || qn.id === "Route" || qn.id === "modified" || qn.id === "portalEditTime" || qn.id === "phoneEditTime" || qn.id === "entryTime" || qn.id === "portalEditEntry" || qn.id === "user_id" || qn.id === "ID" || qn.id === "syncconflict") {
          json.questionList.push({
            "fieldName": page.question[j].id
          });
        }
      }
      j++;
    }
    i++;
  }
  if (locationID != null) {
    if (locationID === "0ul0") {
      locationID = "-1";
    }
    json.locations = [];
    json.locations.push({
      "id": locationID,
      "level": level
    });
  }
  return JSON.stringify(json);
};

//# sourceMappingURL=maps/content.js.map
